// extracted by mini-css-extract-plugin
module.exports = {"products":"styles-module--products--2ylK0"};